import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as display from '../../display'
import * as dms from '../../dms'
import * as fileMgmt from '../../file-mgmt'
import * as me from '../../me'

import { getActionsConfig } from './actions'
import * as cytoscape from './cytoscape'
import * as effects from './effects'
import { registerMarkdownExtension } from './markdown-extension'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * A {@link store.Feature} that manages org charts for Summit
 */
@ngCore.Injectable()
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link cytoscape.Manager} */
  public readonly cytoscapeManager: cytoscape.Manager

  constructor() {
    const schemaFeature = ngCore.inject(dms.schema.Feature)
    const referenceRecordsFeature = ngCore.inject(
      display.referenceRecords.Feature,
    )

    super({
      actions: getActionsConfig(() => this.cytoscapeManager),
      initialState: State.INITIAL,
      name: 'TreeEditor',

      selectors: () => new Selectors(this, schemaFeature),
    })

    const meFeature = ngCore.inject(me.Feature)
    const fileMgmtFeature = ngCore.inject(fileMgmt.Feature)
    this.registerEffects(
      effects.onInitTriggerLoadEdges(),
      effects.onLoadEdgesRequest(meFeature),
      effects.onSaveEditsRelay(),
      effects.onAddNodeRelay(),
      effects.onSaveDataRequest(meFeature),
      effects.onDeleteNodeRelay(),
      effects.onDeleteDataRequest(meFeature),
      effects.onApproveProposalRequest(meFeature),
      effects.onEditNodeValueResolveDisplayBindings(
        schemaFeature,
        referenceRecordsFeature,
      ),
      effects.onEditNodeTriggerLoadPeopleInsights(),
      effects.onLoadPeopleInsightsRequest(meFeature),
      effects.onUploadFile(fileMgmtFeature, meFeature),
    )

    // NOTE: this has side effects
    this.cytoscapeManager = new cytoscape.Manager(this)

    registerMarkdownExtension(this)
  }
}
